module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"academy":"アカデミー","poweredBy":"搭載"}}')
  delete Component.options._Ctor
}
